import axios from 'axios';

export const workflowTruckApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-truck`,
    headers: {
        'Content-Type': 'application/json'
    }
})